module.exports = "mutation UpdateVoucher($data:UpdateVoucherInput!){updateVoucher(data:$data){success}}"